export class SocketMessage {
    type: SocketMessageType
    userId: number
    quoteId: number
    message: string
    value: string
    action1Url: string | null
    action1Text: string | null
    messageId: number | null
}

export enum SocketMessageType {
    BlockingPopup = 1,
    PopUp = 2,
    SilentMessage = 3,
    SilentNotification = 4,
    SilentRefreshInbox = 5,
    ReadInboxMessage = 6,
    ForceLogout = 7,
    LeadsCount = 8,
    SalesCount = 9,
    SilentRefreshWhatsApp = 10,
    LoadPopUpMessage = 11,
    UpdateLoadBalancing = 12,
    ClickablePopup = 13,
    UpdateStoreRoom = 14,
    UpdateWIP = 15,
    IncomingCall = 16,
    IncomingCallCancelled = 17,
    UpdateFleetPos = 18,
    PleaseCallMe = 19,
    QuoteAction = 20,
    QuoteActionCancelled = 21
    
}
